import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
import { ECOSYSTEM_SOURCE, ecosystemStats } from '../data/ecosystem';
const YEARS = [1946, 1980, 2000, 2010, 2026];

/** Deterministic, disconnected activity points — density grows with time. */
const POINTS = Array.from({
  length: 190
}, (_, i) => {
  const t = i / 189;
  const x = 20 + Math.pow(t, 0.72) * 960;
  const spread = 8 + Math.pow(t, 1.6) * 120;
  const y = 176 - Math.pow(t, 2.1) * 120 - i * 37 % 100 / 100 * spread;
  return {
    x,
    y: Math.max(14, y),
    r: 0.9 + i * 13 % 5 / 4
  };
});
const CURVE = `M20,178 ${Array.from({
  length: 60
}, (_, i) => {
  const t = i / 59;
  const x = 20 + t * 960;
  const y = 178 - Math.pow(t, 2.4) * 148;
  return `L${x.toFixed(1)},${y.toFixed(1)}`;
}).join(' ')}`;
export function FragmentedDataSlide() {
  return <Slide index={2} source={ECOSYSTEM_SOURCE} data-id="element-115" data-mp="8khn4l1mnr64">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-116" data-mp="8iofb2fa30wj">
        <div className="max-w-[62%]" data-id="element-117" data-mp="3teo56itlwv1t">
          <Eyebrow data-id="element-118" data-mp="3tfquwnf70rg5">The ecosystem</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-119" data-mp="28edc7aeebzp">
            Venture has spent 80 years creating data — but it still has no
            shared intelligence layer.
          </Title>
        </div>
        <Caption className="max-w-[26%] text-right" data-id="element-120" data-mp="3ofuq4lyo8vzj">
          Every company, round, investor and outcome is recorded somewhere. Almost
          none of it is connected.
        </Caption>
      </div>

      <Reveal delay={0.1} className="relative mt-auto" data-id="element-121" data-mp="3ff6ajmtmqnkj">
        <svg viewBox="0 0 1000 200" className="h-[30vh] w-full" preserveAspectRatio="none" role="img" aria-label="Venture activity from 1946 to 2026 rising sharply while remaining disconnected" data-id="element-122" data-mp="3fgr69frokcjz">
          <path d={CURVE} fill="none" stroke="#3B8CFF" strokeWidth={1.2} opacity={0.5} data-id="element-123" data-mp="2rpu773kzh9q5" />
          {POINTS.map((p, i) => <circle key={i} cx={p.x} cy={p.y} r={p.r} fill={i % 11 === 0 ? '#D8A55A' : i % 5 === 0 ? '#2FBE8F' : '#8FB8F0'} opacity={0.15 + p.x / 1000 * 0.7} data-id="element-124" data-mp="2wnn8pjbcdfk3" data-mpi={i} />)}
          <line x1={20} y1={186} x2={980} y2={186} stroke="#FFFFFF" strokeWidth={0.6} opacity={0.14} data-id="element-125" data-mp="sidp7o4kbvh3" />
        </svg>

        <div className="mt-[1.2vh] flex justify-between" data-id="element-126" data-mp="ohuu9l7di9ao">
          {YEARS.map(year => <span key={year} className="text-[clamp(8px,0.82vw,17px)] tracking-[0.18em] text-white/35" data-id="element-127" data-mp="1l7udqap2as81">
              {year}
            </span>)}
        </div>
      </Reveal>

      <Reveal delay={0.2} className="mt-[3vh] grid grid-cols-8 border-t border-white/12 pt-[2.2vh]" data-id="element-128" data-mp="1c5bcfv0xcnnw">
        {ecosystemStats.map((stat, i) => <div key={stat.label} className={i === 0 ? 'pr-[1vw]' : 'border-l border-white/10 pl-[1vw] pr-[1vw]'} data-id="element-129" data-mp="s0jd96m6ut2" data-mpi={i}>
            <p className="text-[clamp(15px,1.85vw,38px)] leading-none" style={{
          fontFamily: 'var(--font-serif)',
          color: stat.tone ?? '#F4F7FC'
        }} data-id="element-130" data-mp="3rwh27yrqmhk0">
              {stat.value}
            </p>
            <p className="mt-[1vh] text-[clamp(7.5px,0.76vw,16px)] leading-tight text-[#7C8699]" data-id="element-131" data-mp="2ggfwp4wt50zx">
              {stat.label}
            </p>
          </div>)}
      </Reveal>
    </Slide>;
}